import React, {lazy, Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {isPublicEventsPath} from "./theme/themeRoute";

import * as Sentry from '@sentry/react';
import {redactEventGuestLinks} from "./components/pages/Events/eventGuestPrivacy";
import {installFrameResizeObserver} from "./browser/installFrameResizeObserver";

installFrameResizeObserver(window);

Sentry.init({
    dsn: 'https://b9b08b126cf94adda7d916137d60215d@o576474.ingest.sentry.io/5730059',
    integrations: [
        Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.05,
    sendDefaultPii: false,
    beforeSend(event) {
        if (event?.request) {
            delete event.request.cookies;
            delete event.request.data;
            delete event.request.headers;
        }
        if (event?.user) event.user = {id: event.user.id};
        return redactEventGuestLinks(event);
    },
    beforeSendTransaction: redactEventGuestLinks,
    beforeBreadcrumb: redactEventGuestLinks,
});

const OperationalApplication = lazy(() => import('./OperationalApplication'));
const OperationalTv = lazy(() => import('./operationalDisplays/OperationalTv'));
const isTv = /^\/tv(?:\/|$)/.test(window.location.pathname);
const publicEvents = isPublicEventsPath(window.location.pathname);

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<p>Ocurrió un error inesperado.</p>}>
            <Suspense fallback={<div style={{background: publicEvents ? "#f4f7fb" : "#080f1c", color: publicEvents ? "#102035" : "#fff", minHeight: "100vh", padding: 48}}>Cargando…</div>}>
                {isTv ? <OperationalTv /> : <OperationalApplication />}
            </Suspense>
        </Sentry.ErrorBoundary>
    </React.StrictMode>
);
